import { render, staticRenderFns } from "./CloseAllAccounts.vue?vue&type=template&id=6c44f95a&"
import script from "./CloseAllAccounts.vue?vue&type=script&lang=js&"
export * from "./CloseAllAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c44f95a')) {
      api.createRecord('6c44f95a', component.options)
    } else {
      api.reload('6c44f95a', component.options)
    }
    module.hot.accept("./CloseAllAccounts.vue?vue&type=template&id=6c44f95a&", function () {
      api.rerender('6c44f95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/CloseAllAccounts.vue"
export default component.exports